import Vue from "vue";
import { format, parse, formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";

export const $date = {
    format: (date, pattern = "dd/MM/yyyy HH:mm") => {
        if (!date) return null;

        return format(date, pattern);
    },
    safeParse: (date, format) => {
        try {
            return parse(date, format, new Date());
        } catch (e) {
            return false;
        }
    },
    relative: (date) => {
        if (!date) return "";
        try {
            const d = date instanceof Date ? date : new Date(date);
            const s = formatDistanceToNow(d, { addSuffix: true, locale: ptBR });
            return s.charAt(0).toUpperCase() + s.slice(1);
        } catch (e) {
            return "";
        }
    },
}

Vue.prototype.$date = $date;
